<template>
  <button
    type="button"
    :class="[
      'btn ml-1 create-template-btn',
      active ? 'btn-primary' : 'btn-light-secondary',
    ]"
    @click="onButtonClick"
  >
  <span class="">
    <em :class="iconClass" v-if="iconClass" />
  </span>
    <span class="d-inline text-white">{{ label }}</span>
  </button>
</template>

<script>
export default {
  props: ["onClick", "label", "active", "lang","iconClass"],

  methods: {
    onButtonClick() {
      if (this.onClick) this.onClick(this.lang);
    },
  },
};
</script>
